/**
 * Exponential Moving Average (EMA) filter for compass heading
 * Reduces jitter while keeping rotation snappy
 */

export class HeadingSmoothing {
  constructor(alpha = 0.3) {
    this.alpha = alpha // 0-1: higher = more responsive, lower = more stable
    this.smoothedHeading = null
  }

  /**
   * Apply EMA filter to raw heading value
   * @param {number} rawHeading - Raw compass heading (0-360)
   * @returns {number} Smoothed heading (0-360)
   */
  update(rawHeading) {
    if (this.smoothedHeading === null) {
      this.smoothedHeading = rawHeading
    } else {
      // Wrap around 360° boundary
      let diff = rawHeading - this.smoothedHeading
      if (diff > 180) diff -= 360
      if (diff < -180) diff += 360

      this.smoothedHeading += diff * this.alpha
      this.smoothedHeading = (this.smoothedHeading + 360) % 360
    }

    return this.smoothedHeading
  }

  /**
   * Reset filter state
   */
  reset() {
    this.smoothedHeading = null
  }
}
